import React from 'react'
import { AddCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Button from '@SonarCX/components/atoms/Button2'
import Note, { NoteProps } from '../Note'

import { FILE_EXTENSION } from '..'
import useStyles from './styles'

type NotesProps = {
  media: Media[]
  createNote: () => void
} & Pick<NoteProps, 'loading' | 'viewingID' | 'startEdit' | 'deleteNote'>

const Notes: React.FC<NotesProps> = ({
  media,
  loading,
  createNote,
  ...props
}) => {
  const theme = useTheme()

  const showableMedia = React.useMemo(
    () => media.filter(m => m.filename.endsWith(FILE_EXTENSION)),
    [media]
  )

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Button
        onClick={createNote}
        disabled={loading}
        className={classes.create}
        startIcon={
          <AddCircle
            color='white'
            size={theme.size.base}
            variant='Bold'
            className={classes.icon}
          />
        }
      >
        Note
      </Button>

      {showableMedia.map(media => (
        <Note key={media.id} media={media} loading={loading} {...props} />
      ))}
    </div>
  )
}

export default Notes
